/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateGoogleDriveAppInput = {|
  gdriveEnabled?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type updateGoogleDriveMutationVariables = {|
  input: UpdateGoogleDriveAppInput
|};
export type updateGoogleDriveMutationResponse = {|
  +updateGoogleDriveApp: ?{|
    +company: ?{|
      +id: string,
      +gdriveEnabled: ?boolean,
    |}
  |}
|};
export type updateGoogleDriveMutation = {|
  variables: updateGoogleDriveMutationVariables,
  response: updateGoogleDriveMutationResponse,
|};
*/


/*
mutation updateGoogleDriveMutation(
  $input: UpdateGoogleDriveAppInput!
) {
  updateGoogleDriveApp(input: $input) {
    company {
      id
      gdriveEnabled
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateGoogleDriveAppInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateGoogleDriveAppPayload",
    "kind": "LinkedField",
    "name": "updateGoogleDriveApp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gdriveEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateGoogleDriveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateGoogleDriveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateGoogleDriveMutation",
    "operationKind": "mutation",
    "text": "mutation updateGoogleDriveMutation(\n  $input: UpdateGoogleDriveAppInput!\n) {\n  updateGoogleDriveApp(input: $input) {\n    company {\n      id\n      gdriveEnabled\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '227b5a2f1343775ef96144ffb35e8289';

module.exports = node;
